module.exports = __webpack_public_path__ + "img/icon_material_cumulative_hnt_2.3a98175e.webp";